export const WIDTH_PLUS_PADDING = 200 + 8;
export const FLYOUT_ITEM_HEIGHT = 32; // Without padding;
